import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  DirectoryGetRecordsDocument,
  MutationInput_DirectoryController_SaveRecordStatus_Input_Status,
  useDirectorySaveRecordStatusMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';

type Status = 'Active' | 'Archived';

export const useSaveDirectoryRecordStatus = () => {
  const [handle, { loading, error: apolloError }] =
    useDirectorySaveRecordStatusMutation({
      refetchQueries: [DirectoryGetRecordsDocument],
    });

  const error = useError(apolloError);

  return {
    loading,
    error,
    saveStatus: useCallback(
      async (id: string, versionNumber: number, status: Status) => {
        await handle({
          variables: {
            id,
            input: {
              versionNumber,
              status:
                MutationInput_DirectoryController_SaveRecordStatus_Input_Status[
                  status
                ],
            },
          },
        });
      },
      [handle]
    ),
  };
};
